import React from 'react';
import styled from 'styled-components';
import { RectShape } from 'react-placeholder/lib/placeholders';
import "react-placeholder/lib/reactPlaceholder.css";
import { device, numberToCurrency } from 'vqp-common'

import { fetchOrdersHistory, fetchRevenueHistory } from '../../redux/actions/dashboard'
import { BarChart } from './'
import useFetch from '../../utils/useFetch'

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    margin: 15px;

    @media ${device.desktop} {
        grid-template-columns: 1fr 1fr;
    }
`


export const HistoryChartsPanel = ({filterDates}) => {

    const ordersHistory = useFetch(fetchOrdersHistory, filterDates)
    const revenueHistory = useFetch(fetchRevenueHistory, filterDates)

    const drawChart = (title, chart, yFormatter) => {
        if (chart.loading) { 
            return (
                <RectShape color='#E0E0E0' showLoadingAnimation={true} style={{ width: '100%', height: 300 }} />
            )
        } else if (chart.response) {
            return (
                <BarChart 
                    title={title} 
                    labels={chart.response.labels} 
                    datasets={chart.response.datasets} 
                    type="bar" 
                    yFormatters={[yFormatter]}
                    labelFormatter={yFormatter} 
                />
            )
        }
        return null
    }

    const yFormatter = (val) => {
        return numberToCurrency(Number(val))
    }
    
    return (
        <Grid>
            {drawChart("Histórico de pedidos", ordersHistory)}
            {drawChart("Histórico de faturamento", revenueHistory, yFormatter)}
        </Grid>
    )
}